import { render, staticRenderFns } from "./m-restricted-table-header-cell.vue?vue&type=template&id=cb9dbc4a&scoped=true&"
import script from "./m-restricted-table-header-cell.vue?vue&type=script&lang=js&"
export * from "./m-restricted-table-header-cell.vue?vue&type=script&lang=js&"
import style0 from "./m-restricted-table-header-cell.vue?vue&type=style&index=0&id=cb9dbc4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9dbc4a",
  null
  
)

export default component.exports